export default "/img/sasfinlogo.png"